export const SENDGRID_OVERRIDES = {};
